class ConfigService {
  API_URL = "http://138.201.249.173:8091";
  API_URL_PAYMENT = "http://138.201.249.173:8085";
  PUBLIC_URL = "http://138.201.249.173:8092";
  VIDEO_URL = "http://138.201.249.173:4700";

  /* API_URL
 API_URL_PAYMENT
 PUBLIC_URL
 VIDEO_URL */
}

export default new ConfigService();
